import { FileTypes } from "../enum/file-types-enum";

export function convertBase64toFileAndDownload(fileType: string, base64File: string, fileName: string) {
  const fileTypeName = FileTypes[fileType];
  if (base64File) {
    let fileLink = document.createElement('a');
    fileLink.href = `data:${fileTypeName};base64,${base64File}`;
    fileLink.download = fileName;
    fileLink.click();      
    fileLink.remove();
  }
}